var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSorticons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 15C11.7761 15 12 14.7761 12 14.5V2.70711L15.1464 5.85355C15.3417 6.04882 15.6583 6.04882 15.8536 5.85355C16.0488 5.65829 16.0488 5.34171 15.8536 5.14645L11.8536 1.14645C11.6583 0.951184 11.3417 0.951184 11.1464 1.14645L7.14645 5.14645C6.95118 5.34171 6.95118 5.65829 7.14645 5.85355C7.34171 6.04882 7.65829 6.04882 7.85355 5.85355L11 2.70711V14.5C11 14.7761 11.2239 15 11.5 15Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 1C4.77614 1 5 1.22386 5 1.5V13.2929L8.14645 10.1464C8.34171 9.95118 8.65829 9.95118 8.85355 10.1464C9.04882 10.3417 9.04882 10.6583 8.85355 10.8536L4.85355 14.8536C4.65829 15.0488 4.34171 15.0488 4.14645 14.8536L0.146447 10.8536C-0.0488155 10.6583 -0.0488155 10.3417 0.146447 10.1464C0.341709 9.95118 0.658292 9.95118 0.853554 10.1464L4 13.2929V1.5C4 1.22386 4.22386 1 4.5 1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorticons);
export default __webpack_public_path__ + "static/media/sorticons.1ccce3691e0de3fb8f75acc16bf6f1cc.svg";
export { ForwardRef as ReactComponent };